"use strict";

var _interopRequireDefault = require("/data/www/prod-cn-snote-manage/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getrecordList = getrecordList;
var _request = _interopRequireDefault(require("@/utils/request"));
//设备版本
function getrecordList(data) {
  return (0, _request.default)({
    url: 'system/business/android/store/record/query',
    method: 'post',
    headers: {
      "Content-Type": 'application/json',
      "x-access-token": window.localStorage.getItem('token')
    },
    timeout: 20000,
    data: data
  });
}